import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

// Iconos internos de Vuetify (chevrons de selects, checks de alerts, paginación…)
// renderizados con Lucide mediante el componente global LIcon.
const lucide = (name: string) => ({ component: 'LIcon', props: { name } })

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
    values: {
      complete: lucide('check'),
      cancel: lucide('circle-x'),
      close: lucide('x'),
      delete: lucide('circle-x'),
      clear: lucide('x'),
      success: lucide('circle-check'),
      info: lucide('info'),
      warning: lucide('triangle-alert'),
      error: lucide('circle-alert'),
      prev: lucide('chevron-left'),
      next: lucide('chevron-right'),
      checkboxOn: lucide('square-check'),
      checkboxOff: lucide('square'),
      checkboxIndeterminate: lucide('minus'),
      delimiter: lucide('circle'),
      sort: lucide('arrow-up'),
      expand: lucide('chevron-down'),
      menu: lucide('menu'),
      subgroup: lucide('chevron-down'),
      dropdown: lucide('chevron-down'),
      radioOn: lucide('circle-dot'),
      radioOff: lucide('circle'),
      edit: lucide('pencil'),
      ratingEmpty: lucide('star'),
      ratingFull: lucide('star'),
      ratingHalf: lucide('star-half'),
      loading: lucide('loader-circle'),
      first: lucide('chevrons-left'),
      last: lucide('chevrons-right'),
      unfold: lucide('chevrons-up-down'),
      file: lucide('paperclip'),
      plus: lucide('plus'),
      minus: lucide('minus'),
    },
  },
  theme: {
    dark: false, // valor inicial
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#2c7cff',
        background: '#FFFFFF',
        text: '#0c193a',
        border: '#D1D5DB',
        // ... altres colors
      },
      dark: {
        primary: '#5a8cff',
        background: '#1E1E1E',
        text: '#FFFFFF',
        border: '#363636',
        // ... altres colors pel tema fosc
      }
    }
  }
})
